import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-return",
  "use": "icon-icon-return-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-return\"><path d=\"M262.7584 253.952h355.5328a336.384 336.384 0 1 1 0 672.6656H169.8816a56.1152 56.1152 0 0 1 0-112.128h448.4096a224.256 224.256 0 1 0 0-448.4096H258.7648l64.9216 64.8192a56.1152 56.1152 0 1 1-79.36 79.2576L85.8112 351.6416a55.9104 55.9104 0 0 1 0-79.2576l158.5152-158.5152a56.1152 56.1152 0 1 1 79.36 79.2576z m0 0\" p-id=\"6235\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol